import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import LandingBox from "./LandingBox";
import Sidebar from "../Sidebar";

export default function Landing() {
  return (
    <>
      <Container fluid style={{ backgroundColor: "#f1f2f3" }}>
        <Row>
          <Sidebar />
          <Col lg={10}>
            <Row className="g-4 p-4">
              <LandingBox title="Landing Page" navigatePath="/landingUpload" />
              <LandingBox title="Order List" navigatePath="/orderList" />
              <LandingBox title="New Product" navigatePath="/newProduct" />
              <LandingBox title="Sales Report" navigatePath="/salesReport" />
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
}
